import React from 'react';

const Kontakt: React.FC = () => {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h1>Kontakt oss</h1>
      <p style={{ marginTop: '1rem' }}>
        For spørsmål om Sykkelfest, ta kontakt på:{' '}
        <a href="mailto:post@sykkelfest.no">post@sykkelfest.no</a>
      </p>
    </div>
  );
};

export default Kontakt;
